import React from 'react';
import ReactTable from 'react-table';
import FontAwesome from 'react-fontawesome';
import firebase from 'firebase/app';
import 'firebase/database';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import BoothsButton from './booths-button';
import CreateExhibitorDialog from './create-exhibitor-dialog';
import EditExhibitorDialog from './edit-exhibitor-dialog';

/** @class ExhibitorList
  * A component that list the exhibitor information
  * for all shows in the platform.
  */
export default class ExhibitorList extends ReactFireComponent {
  /** @constructor
    * Constructs a new instance of ExhibitorList
    */
  constructor(props) {
    super(props);
    this.state = {
      exhibitors: [],
      showNewDialog: false,
      selectedExhibitor: null
    }
    this.toggleNewDialog = this.toggleNewDialog.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }
  /** @method componentWillMount
    * Binds the component to the Firebase database
    */
  componentWillMount() {
    this.bindAsArray('/exhibitors', 'exhibitors');
  }
  /** @method componentWillUnmount
    * Unbinds the component from firebase.
    */
  componentWillUnmount() {
    this.unbind('exhibitors');
  }
  /** @method toggleNewDialog
    * Hides or shows the exhibitor creation dialog
    */
  toggleNewDialog() {
    this.setState({showNewDialog: !this.state.showNewDialog});
  }
  /** @method handleEdit
    * Allows the selection of an exhibitor from the list to edit.
    * @param {string} id - the identity of the exhibitor to edit
    */
  handleEdit(id) {
    this.setState({
      selectedExhibitor: id
    });
  }
  /** @method handleRemove
    * Allows the removal of an exhibitor from the list.
    * @param {string} id - the identifier of the exhibitor
    */
  handleRemove(id) {
    if(window.confirm("Are you sure?  This will permanently remove them from the Vexpo Admin Platform.")) {
      firebase.database().ref(`/exhibitor/${id}`).set(null);
    }
  }
  /** @method render
    * Renders a table of exhibitors, with buttons
    * linking to thier booths.
    */
  render() {
    var columns = [
      {Header: 'Company', accessor: 'company'},
      {Header: 'Brand', accessor: 'brand'},
      {Header: 'Contact', accessor: 'contact'},
      {Header: 'Phone', accessor: 'phone'},
      {Header: 'Email', accessor: 'email'},
      {Header: 'Booths', accessor: 'booths', filterable: false, Cell: (row) => (
        <BoothsButton booths={row.value} exhibitor={row.original}/>
      )},
      {Header: '', accessor: 'id', filterable: false, Cell: (row) => (
        <span>
        <FontAwesome name="edit"
          style={{color:'orange', cursor: 'pointer'}}
          onClick={()=>this.handleEdit(row.value)}
          />
        <FontAwesome name="times"
          style={{color:'red', cursor: 'pointer'}}
          onClick={()=>this.handleRemove(row.value)}
          />
        </span>
      )}
    ];
    const selectedExhibitor = this.state.exhibitors.find(exhibitor => {
      return exhibitor.id === this.state.selectedExhibitor;
    });
    const editorDialog = selectedExhibitor
      ? <EditExhibitorDialog exhibitor={selectedExhibitor} show={selectedExhibitor !== null} onExit={()=>{this.setState({selectedExhibitor: null})}} />
      : '';
    return (
      <div>
        <button className="btn btn-success" onClick={this.toggleNewDialog}>
          <FontAwesome name="plus"/>
          Add New Exhibitor
        </button>
        <CreateExhibitorDialog show={this.state.showNewDialog} onExit={this.toggleNewDialog}/>
        {editorDialog}
        <ReactTable data={this.state.exhibitors} columns={columns} filterable/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/exhibitor-list/exhibitor-list.js